<template>
  <div>
    <el-dialog title="新增直营分店" :visible.sync="dialogVisible" width="900px" @close="$emit('update:visible', dialogVisible)">
      <div class="step-view">
        <el-steps :active="stepIndex" align-center>
          <el-step title="商户基本信息填写"></el-step>
          <el-step title="商户费率设置"></el-step>
          <el-step title="审核"></el-step>
        </el-steps>
      </div>
      <el-form label-width="100px" ref="form" :model="form" :rules="rules" v-show="stepIndex === 1">
        <h3 size="medium">基本信息</h3>
        <el-form-item label="店铺类型" prop="shopType">
          <el-select v-model="form.shopType" disabled>
            <el-option label="总店" value="1"></el-option>
            <el-option label="加盟分店" value="0"></el-option>
            <el-option label="直营分店" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="总店商户编号">
          <el-input class="form-input" v-model="form.headShopMerchantId" placeholder="总店商户编号" disabled></el-input>
        </el-form-item>
        <el-form-item ref="addFormUserNameItem" label="登录账号" prop="userName" :error="userNameItemError">
          <el-input class="form-input" v-model="form.userName" placeholder="建议使用手机号，支持8~20位数字/字母" prop="userName" @blur="checkUserName"></el-input>
          <span class="check-username-loading-view" v-show="checkLoading">
            <i class="el-icon-loading"></i>
            <span>检测中...</span>
          </span>
        </el-form-item>
        <el-form-item label="登录密码" prop="userPassword">
          <el-input class="form-input" v-model="form.userPassword" placeholder="8~20位数字或字母组合，若不填写，默认设置为Aa123456" ></el-input>
        </el-form-item>
        <el-form-item label="绑定手机" prop="mobile">
          <el-input class="form-input" v-model="form.mobile" placeholder="11位正确手机号，用户登录账号密码找回"></el-input>
        </el-form-item>
        <el-form-item label="回调地址" prop="notifyAddress">
          <el-input class="form-input" v-model="form.notifyAddress"></el-input>
        </el-form-item>
        <h3>商户入网信息</h3>
        <el-form-item label="分店名称" prop="merchantName">
          <el-input class="form-input" v-model="form.merchantName" placeholder="分店名称，5~20个字"></el-input>
        </el-form-item>
        <el-form-item label="经营地址" required>
          <el-row type="flex">
            <el-form-item prop="province" class="form-flex-item">
              <el-select
                v-model="form.province"
                placeholder="请选择省"
                @change="setProv"
                clearable
                filterable
                style="width:120px;">
                <el-option
                  v-for="item in pro_list"
                  :key="item.F_province_no"
                  :label="item.F_province_name"
                  :value="item.F_province_name" >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="city" class="form-flex-item">
              <el-select
                v-model="form.city"
                placeholder="请选择市"
                @change="setCity"
                @focus="handleCityFocus"
                clearable
                filterable
                style="width: 120px;">
                <el-option
                  v-for="item in city_list"
                  :key="item.F_city_no"
                  :label="item.F_city_name"
                  :value="item.F_city_name">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="area" class="form-flex-item">
              <el-select
                v-model="form.area"
                placeholder="请选择区"
                @change="setArea"
                @focus="handleAreaFocus"
                clearable
                filterable
                style="width: 120px;">
                <el-option
                  v-for="item in area_list"
                  :key="item.F_area_no"
                  :label="item.F_area_name"
                  :value="item.F_area_name">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="address" class="form-input">
              <el-input v-model="form.address" placeholder="详细地址需超过5个字，详细到门牌号"></el-input>
            </el-form-item>
          </el-row>
        </el-form-item>
        <h3>证照信息-三合照</h3>
        <el-row>
          <el-col :span="8">
            <el-form-item prop="doorPhoto" label-width="0">
              <upload-img
                label="门头照"
                :required="true"
                placeholder="门头照"
                valueName="doorPhoto"
                v-model="form.doorPhoto"
                :value="form.doorPhoto"
                @success="uploadSuccess"></upload-img>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="cashierDesk" label-width="0">
              <upload-img
                label="收银台照"
                :required="true"
                placeholder="收银台照"
                valueName="cashierDesk"
                v-model="form.cashierDesk"
                :value="form.cashierDesk"
                @success="uploadSuccess"></upload-img>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="businessInside" label-width="0">
              <upload-img
                label="经营场所照"
                :required="true"
                placeholder="经营场所照"
                valueName="businessInside"
                v-model="form.businessInside"
                :value="form.businessInside"
                @success="uploadSuccess"></upload-img>
            </el-form-item>
          </el-col>
        </el-row>
        <h3>其他信息</h3>
        <el-form-item label="支付APPID" prop="publicsignalAppid">
          <el-input class="form-input" auto-complete="off" v-model="form.publicsignalAppid"></el-input>
        </el-form-item>
        <el-form-item label="授权目录" prop="publicsignalAuthorizationDirectory">
          <el-input class="form-input" auto-complete="off" v-model="form.publicsignalAuthorizationDirectory"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" v-if="stepIndex === 1">
        <el-button @click="cancelSubmit">取消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="nextStep">下一步</el-button>
      </span>
      <rate-form v-if="stepIndex === 2" :is-add-shop="true" :fatherId="form.headShopMerchantId" :id="merchantId" @submit="submit"></rate-form>
    </el-dialog>
  </div>
</template>

<script>
import qs from 'qs'
import uploadImg from '@/components/upload/uploadImg'
import rateForm from './rateForm'
import md5 from 'js-md5'
import { checkUsername, directBranchRegister } from '@/api/merchant'
// const topRateNum = 50 // 代理商成本、商户费率默认封顶值
// const topFeeNum = 500 // 代理商成本、商户手续费默认封顶值
export default {
  name: 'AddShop',
  components: {
    uploadImg,
    rateForm
  },
  props: {
    // 该分店所属总店的数据
    fatherData: {
      type: Object,
      default: function () {
        return {}
      },
      required: true
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      stepIndex: 1,
      dialogVisible: false,
      form: {
        shopType: '2', // 店铺类型
        headShopMerchantId: '',
        userName: '',
        userPassword: '',
        mobile: '',
        notifyAddress: '',
        merchantName: '',
        province: '',
        city: '',
        area: '',
        address: '',
        doorPhoto: '',
        cashierDesk: '',
        businessInside: '',
        publicsignalAppid: '',
        publicsignalAuthorizationDirectory: ''
      },
      originPsd: '', // 加密前的密码
      rules: {
        userName: [
          { required: true, message: '请输入登录账号', trigger: 'blur' }
        ],
        userPassword: [{
          validator: (rule, value, callback) => {
            if (/^[a-zA-Z0-9]{8,20}$/.test(value) || value === '') {
              callback()
            } else {
              callback(new Error('请输入8~20位数字/字母组合密码'))
            }
          },
          trigger: 'blur'
        }],
        mobile: [{
          validator: (rule, value, callback) => {
            if (!(/^\d{11,11}$/.test(value))) {
              callback(new Error('请输入11位手机号码'))
            } else {
              callback()
            }
          },
          required: true,
          trigger: 'blur'
        }],
        notifyAddress: [{ pattern: /^\S*$/, message: '空格无效，请重新输入', trigger: 'blur' }],
        merchantName: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入分店名称'))
            } else {
              if (!(/^\S*$/.test(value))) {
                callback(new Error('空格无效，请重新输入'))
              } else if (/(?!^\w+$)^.{5,20}$/.test(value)) {
                callback()
              } else {
                callback(new Error('分店名称为长度5~20的汉字或汉字与数字组合'))
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        province: [{
          required: true,
          message: '请输入省份',
          trigger: 'change'
        }],
        city: [{
          required: true,
          message: '请输入市级',
          trigger: 'change'
        }],
        area: [{
          required: true,
          message: '请输入区域',
          trigger: 'change'
        }],
        address: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入详细地址'))
            } else {
              if (!(/^\S*$/.test(value))) {
                callback(new Error('空格无效，请重新输入'))
              } else if (/(?!^\w+$)^.{5,40}$/.test(value)) {
                callback()
              } else {
                callback(new Error('请输入5位以上详细地址'))
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        doorPhoto: [
          { required: true, message: '请上传门头照', trigger: 'change' }
        ],
        cashierDesk: [
          { required: true, message: '请上传收银台照', trigger: 'change' }
        ],
        businessInside: [
          { required: true, message: '请上传经营场所照', trigger: 'change' }
        ],
        publicsignalAppid: [
          { required: false, message: '请填写支付APPID', trigger: 'blur' },
          { pattern: /^\S*$/, message: '空格无效，请重新输入', trigger: 'blur' },
          { pattern: /^wx\S{16}$/, message: '支付APPID必须是wx开头的18位字符', trigger: 'blur' }
        ],
        publicsignalAuthorizationDirectory: [
          { pattern: /^\S*$/, message: '空格无效，请重新输入', trigger: 'blur' },
          { pattern: /^(http|https):\/\/\S+\/$/, message: '授权目录必须以http或https开头，以/结尾', trigger: 'blur' }
        ]
      },
      checkLoading: false,
      userNameItemError: '',
      pro_list: [],
      city_list: [],
      area_list: [],
      submitLoading: false,
      domain: 'https://baseweb.lszzg.com/',
      showForm: 'rate', // 显示的表单
      merchantId: ''
    }
  },
  watch: {
    visible (val) {
      this.dialogVisible = val
    }
  },
  mounted () {
    this.getProv()
    // this.getRate();//获取商户默认成本
    this.form.headShopMerchantId = this.fatherData.headShopMerchantId
    this.dialogVisible = this.visible
  },
  methods: {
    // 获取省列表
    getProv () {
      const that = this
      this.$jquery.ajax({
        type: 'get',
        async: false,
        dataType: 'jsonp',
        url: that.domain + 'leposweb/channel/get-all-province.do?sessionId=' + that.$store.state.user.sessionId + '&userName=' + that.$store.getters.userName,
        contentType: 'application/json; charset=utf-8',
        success: function (res) {
          // eslint-disable-next-line no-eval
          that.pro_list = eval(res.list)
        }
      })
    },
    // 获取市列表
    getCity () {
      const that = this
      let provinceName = that.form.province
      provinceName = qs.stringify({ provinceName: provinceName })
      this.$jquery.ajax({
        type: 'GET',
        async: false,
        dataType: 'jsonp',
        data: provinceName,
        url: that.domain + 'leposweb/home/getcity.do',
        contentType: 'application/json; charset=utf-8',
        success: function (res) {
          // eslint-disable-next-line no-eval
          that.city_list = eval(res.list)
          if (that.form.province === '云南省') {
            that.city_list = that.city_list.filter(function (item) {
              return item.F_city_name !== '普洱市' && item.F_city_name !== '临沧市' && item.F_city_name !== '西双版纳傣族自治州' && item.F_city_name !== '德宏傣族景颇族自治州'
              // return item.F_city_no !== 5335 && item.F_city_no !== 5309 && item.F_city_no !== 5328 && item.F_city_no !== 5331
            })
          }
        }
      })
    },
    // 获取区域
    getArea () {
      const that = this
      let cityName = that.form.city
      cityName = qs.stringify({ cityName: cityName })
      this.$jquery.ajax({
        type: 'get',
        async: false,
        dataType: 'jsonp',
        data: cityName,
        url: that.domain + 'leposweb/home/getarea.do',
        contentType: 'application/json; charset=utf-8',
        success: function (json) {
          // eslint-disable-next-line no-eval
          that.area_list = eval(json.list)
        }
      })
    },
    // 设置省
    setProv (value) {
      if (value) {
        this.form.province = value
        if (this.form.province) {
          this.getCity()
        }
      }
      this.form.city = ''
      this.form.area = ''
      this.form.address = ''
    },
    // 设置市
    setCity (value) {
      if (value) {
        this.form.city = value
        if (this.form.city) {
          this.getArea()
        }
      }
      this.form.area = ''
      this.form.address = ''
    },
    /**
             * 选择城市获取焦点
             */
    handleCityFocus () {
      if (this.form.province && this.city_list.length === 0) {
        this.getCity()
      }
    },
    // 设置区
    setArea (value) {
      if (value) {
        this.form.area = value
      }
      this.form.address = ''
    },
    /**
             * 选择地区获取焦点
             */
    handleAreaFocus () {
      if (this.form.city && this.area_list.length === 0) {
        this.getArea()
      }
    },
    /* 检测商户账号可用性 */
    checkUserName () {
      var userName = this.form.userName
      if (userName === '') {
        this.$message({
          message: '请输入登录账号',
          type: 'warning'
        })
        return false
      }
      userName = qs.stringify({ userName: userName })
      this.checkLoading = true
      this.userNameItemError = ''
      checkUsername(userName).then(data => {
        this.checkLoading = false
        if (parseInt(data.error_code) === 0) {
          this.$message({
            message: data.error_msg,
            type: 'success'
          })
        } else {
          this.userNameItemError = data.error_msg
          this.$message({
            message: data.error_msg,
            type: 'warning'
          })
        }
      })
    },
    // 上传图片成功回调
    uploadSuccess (data) {
      const name = data.valueName
      this.form[name] = data.path
    },
    // 取消提交表单
    cancelSubmit () {
      this.dialogVisible = false
      this.$emit('update:visible', false)
    },
    // 商户进件提交表单
    async nextStep () {
      const that = this
      let result
      that.$refs.form.validate((valid) => {
        result = valid
      })
      if (!result) {
        return
      }
      that.$confirm('是否确认提交', '提示', {}).then(() => {
        that.submitLoading = true
        const pw = this.form.userPassword
        that.originPsd = this.form.userPassword
        if (pw) { this.form.userPassword = md5(pw) }
        let data = that.form
        data = qs.stringify(data)
        directBranchRegister(data).then(data => {
          that.submitLoading = false
          that.form.userPassword = that.originPsd
          if (parseInt(data.error_code) === 0) {
            that.merchantId = data.merchantId
            that.stepIndex = 2
            that.$message({
              message: data.error_msg,
              type: 'success'
            })
          } else {
            that.$message({
              showClose: true,
              message: data.error_msg,
              type: 'error'
            })
            that.form.userPassword = ''
          }
        }).catch(() => {
          that.$message({
            showClose: true,
            message: data.error_msg,
            type: 'error'
          })
          that.form.userPassword = that.originPsd
        })
      })
    },
    // 商户费率提交表单
    submit (value) {
      const that = this
      if (!value) {
        that.stepIndex = 3
        that.$emit('submit', '')
        that.$emit('update:visible', false)
      } else {
        that.$emit('submit', '')
        that.$emit('update:visible', false)
      }
    }
  }
}
</script>

<style scoped rel="stylesheet/scss" lang="scss">
    .form-input {
        width: 300px;
    }
    .form-flex-item {
        margin-right: 5px;
    }
    /* 费率表单 */
    .merList{
        width: 100%;
        padding-left: 0;
        list-style: none;
        line-height: 40px;
        margin-top: 0;
        margin-bottom: 0;
        border-right: 1px solid #ccc;
        border-left: 1px solid #ccc;
        border-top: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        li{
            width: 19%;
            text-align: center;
            display: inline-block;
            border-right: 1px solid #ccc;}
        li:last-child{ border-right: 0;}
        input {border: 0;width: 75%; text-align: center;}
        .el-input__inner {border: 0; text-align: center;}
    }
    .merList1{
        width: 60%;
        li {
            width: 49%;
        }
    }
    .unionMerList{
        width: 100%;
        padding-left: 0;
        list-style: none;
        line-height: 40px;
        margin-top: 0;
        margin-bottom: 0;
        border-right: 1px solid #ccc;
        border-left: 1px solid #ccc;
        border-top: 1px solid #ccc;
        border-bottom: 1px solid #ccc;

        li{
            width: 24%;
            text-align: center;
            display: inline-block;
            border-right: 1px solid #ccc;}
        li:last-child{ border-right: 0;}
        input {border: 0;width: 75%; text-align: center;}
        .el-input__inner {border: 0; text-align: center;}
    }
</style>
